import { loadAuth, setAuth } from "utils/storage";
import { apiAuth, apiAuth0 } from "./index";
import { IAuthResult, ILoginWithCaptchaParams, ILoginWithCodeParams, ISignupParams } from "./AuthService";

const MS_IN_SEC = 1000;

export const isAuthenticated = async () => {
  try {
    return !!(await checkSession());
  } catch (e) {
    console.warn(e);
    return false;
  }
};

const checkSession = async (): Promise<IAuthResult | null> => {
  const authData: { exp: number; data: IAuthResult } = loadAuth();

  if (authData) {
    const currentTime = (new Date().getTime() / MS_IN_SEC);

    if (authData.exp >= currentTime) {
      return authData.data;
    } else if (authData?.data?.refresh_token) {
      try {
        const data = await apiAuth.refresh({
          refresh_token: authData.data.refresh_token,
        });

        saveAuthData(data);
        return data;
      } catch (e) {
        setAuth();
      }
    }
  }

  return null;
};

const saveAuthData = (data: IAuthResult) => {
  const currentTime = (new Date().getTime() / MS_IN_SEC);

  setAuth({
    data,
    exp: data.expires_in + currentTime
  });
};

export const login = async (props: ILoginWithCaptchaParams): Promise<void> => {
  saveAuthData(await apiAuth.login<ILoginWithCaptchaParams>(props));
  window.location.reload();
};

export const signup = async (params: ISignupParams): Promise<void> => {
  await apiAuth0.signup(params);

  saveAuthData(await apiAuth.login<ILoginWithCodeParams>({
    username: params.username,
    password: params.password,
    validation_code: params.validation_code,
    validation_token: params.validation_token,
  }));

  window.location.reload();
};

export const logout = () => {
  setAuth();
  window.location.reload();
};

export const getAccessToken = async () => {
  const result = await checkSession();

  if (!result) {
    return null;
  }

  return result.access_token ?? null;
};
